// extracted by mini-css-extract-plugin
export default {"not_found_image":"notFound_not_found_image__Ta4Yb","not_found_wrapper":"notFound_not_found_wrapper__EWuQ0","not_found_text":"notFound_not_found_text__g1O01"};